module.exports = __webpack_public_path__ + "static/media/header-resultaten-background.f8faa295.jpg";